import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import PropTypes from 'prop-types';

//actions:
import { navigate, openDialog, setSaveState } from '../actions';

import { getData } from '../dataLib';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import FolderIcon from '@material-ui/icons/Folder';

const drawerWidth = 160;

const styles = theme => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
        borderRight: 'none',
    },
    toolbar: {
        display: 'block',
        minHeight: 93,
    },
    avatar: {
        width: 30,
        height: 30,
    },
    listItem: {
        padding: '20px 0 20px 20px !important',
    },
    listItemText: {
        paddingRight: 0,
        paddingLeft: 8,
    },
    listTitleFolder: {
        padding: '15px 5px 15px 10px !important',
    },
    listItemFolder: {
        marginLeft: 10,
    },
    selected: {
        backgroundColor: "#a2398d !important",
        fontWeight: 600
    },
    textListItem: {
        fontSize: 13,
        fontWeight: 400,
        margin: 0,
    },
    textSelected: {
        fontSize: 13,
        fontWeight: 600,
        color: "white !important",
        margin: 0,
    },
    listavatar:{
        minWidth: 0
    }
});

class LeftDrawer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: {},
            selected: "",
            arcade_list: false,
            ventas_list: false,
            redemption_list: false
        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.section.sections !== this.props.section.sections) {
            this.filterReportlistOptions();
        }
        if (this.props.section.selected !== prevProps.section.selected) {
            const selected = this.props.section.sections[this.props.section.selected].find(i => i.children.length === 0);
            if (selected) {
                this.setState((state) => ({ open: {}, selected: selected.id }));
                this.props.navigate(selected.value);
            }
            else this.setState({ open: {}, selected: "" });
        }
    }

    filterReportlistOptions = () => {

        const perfil = this.props.userProfile.selectedCentroProfile ? this.props.userProfile.selectedCentroProfile.iPerfil : 100;

        getData('NaReport/Listas?i_profile=' + perfil,
            (response) => {
                this.setState({ ...this.state, ventas_list: response.data.ventas, arcade_list: response.data.arcade, redemption_list: response.data.redemption });
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching reports ' + error
                }, 'error_get_report_lists', false, 'sm');
            },
            this.props.user,
        );
    }

    handleOpenClick = (value, id) => {
        
        const newOpen = { ...this.state.open };
        newOpen[id] = !this.state.open[id];
        this.setState({ open: newOpen, selected: id });
        
        if (value !== '') {
            if (this.props.saveState.pending) {
                this.props.openDialog('ConfirmationDialog', {
                    message: 'Existen cambios no guardados. Desea abandonar la sección y perder los cambios?',
                    acceptHandler: () => {
                        this.setState((state) => ({ ...state, selected: id }));
                        this.props.setSaveState(false);
                        this.props.navigate(value);
                    }
                }, 'left-drawer-confirmation-message', false, 'sm');
            }
            else {
                this.props.navigate(value);
            }
        }

    }

    handleOptionClick = (value, id) => {

        if (this.props.saveState.pending) {
            this.props.openDialog('ConfirmationDialog', {
                message: 'Existen cambios no guardados. Desea abandonar la sección y perder los cambios?',
                acceptHandler: () => {
                    this.setState((state) => ({ ...state, selected: id }));
                    this.props.setSaveState(false);
                    this.props.navigate(value);
                }
            }, 'left-drawer-confirmation-message', false, 'sm');
        }
        else {
            this.setState((state) => ({ ...state, selected: id }));
            //this.props.history.push("/" + value);
            this.props.navigate(value);
        }
    }

    mapStructure = (nodes, index) => {

        const { classes } = this.props;


        return nodes.map((node) => {

            if (node.children.length === 0) {
                if (node.id === "inf_ventas" && this.state.ventas_list === false) return <div></div>;
                if (node.id === "inf_arcade" && this.state.arcade_list === false) return <div></div>;
                if (node.id === "inf_redemption" && this.state.redemption_list === false) return <div></div>;
                return (
                    <ListItem
                        button
                        key={node.id}
                        divider={node.divider}
                        onClick={() => { this.handleOptionClick(node.value, node.id) }}
                        selected={node.id === this.state.selected}
                        classes={{ selected: classes.selected }}
                        className={classes.listItem}
                    >

                        <p key={node.id} className={node.id === this.state.selected ? classes.textSelected : classes.textListItem}>{node.text}</p>
                    </ListItem>
                )
            }
            else {
                return [
                    <ListItem
                        className={classes.listTitleFolder}
                        button
                        key={node.id}
                        divider={node.divider}
                        onClick={() => { this.handleOpenClick(node.value, node.id) }}
                    >

                        <ListItemAvatar className={classes.listavatar}>
                            <Avatar className={classes.avatar}>
                                <FolderIcon />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText className={classes.listItemText} primaryTypographyProps={{ variant: "subtitle2", color: node.id === this.state.selected ? 'secondary' : 'inherit' }} primary={node.text} />
                        {this.state.open[node.id] ? <ExpandLess /> : <ExpandMore />}

                    </ListItem>,
                    <Collapse key={"collapse_" + node.id} in={this.state.open[node.id]} timeout="auto" unmountOnExit>
                        <List key={"list_" + node.id} component="div" disablePadding className={classes.listItemFolder}>
                            {this.mapStructure(node.children, index + 1)}
                        </List>
                    </Collapse>
                ]
            }

        })
    }


    render() {

        const { classes } = this.props;

        //const options = drawerOptions[this.props.section];

        let options = [];

        if (this.props.section.selected !== '') {
            options = this.props.section.sections[this.props.section.selected];
        }
        
        if(this.props.section.selected === '') return null;

        return (
            <Drawer
                className={classes.drawer}
                variant="permanent"
                classes={{
                    paper: classes.drawerPaper,
                }}
            >

                <div className={classes.toolbar} />

                <List>
                    {this.mapStructure(options, 0)}
                </List>

            </Drawer>
        );

    };

};

LeftDrawer.propTypes = {
    //state:
    user: PropTypes.object,
    section: PropTypes.object,
    //dispatch:
    navigate: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        section: state.section,
        saveState: state.saveState,
        userProfile: state.userProfile
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate: navigate,
        openDialog,
        setSaveState
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(LeftDrawer)));
